import API_CLIENT from "../../utils/Api";

export async function GetSupportTickets(currentPage) {
  return await API_CLIENT.get(`/support-tickets?page=${currentPage}`);
}

export async function CreateSupportTicket(payload) {
  return await API_CLIENT.post("/support-tickets", payload);
}
